import { Box, Grid, IconButton, styled, useTheme } from "@mui/material";

import { History } from "assets/Icon";
import { Link } from "react-router-dom";

function Header() {
  const theme = useTheme()

  return (
    <Grid item xs={12}>
      <BoxHeader>
        <IconButton
          aria-label="history"
          size="small"
          component={Link}
          to={"/referral-history"}
        >
          <History color={theme.palette.secondary.main} />
        </IconButton>
      </BoxHeader>
    </Grid>
  );
}

const BoxHeader = styled(Box)(({ theme }) => ({
  direction: "rtl",
  "ion-icon": {
    color: theme.palette.secondary.main,
    fontSize: "18px",
  },
}));
export default Header;
